import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { apiGet } from '../API/Api_Url';

function PrivacyPolicy() {
  const [Privacypolicy, setPrivacypolicy] = useState('');
  const [IsUploading, setIsUploading] = useState(false);
  const GetPrivacypolicy = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet('api/admin/GetPrivacyPolicy');
      setPrivacypolicy(response?.data?.PrivacyPolicy);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    GetPrivacypolicy()
  }, []);

  const Loader = () => (
    <div className="flex justify-center items-center h-[100vh]">
      <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
    </div>
  );


  return (
    <>
      <Navbar />
      {IsUploading ?
        <>
          <Loader />
        </>
        :
        <>
          <div className='Terms-banner'>
            <h3>Privacy Policy</h3>
            <p>Post your construction or renovation requirements and get connected with our network of Professionals.</p>
          </div>
          <div className='terms'>
            <div
              dangerouslySetInnerHTML={{ __html: Privacypolicy }}
              style={{ color: 'black', fontSize: '14px', lineHeight: '1.6' }}
            >
            </div>
            {/* <p><strong>Effective Date:</strong> [Insert Date]</p>
        <br />
        <p>
          At Professional House, we are committed to protecting your privacy and ensuring the security of your personal information.
          This Privacy Policy outlines how we collect, use, and safeguard the data you provide when you interact with us.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of personal information:</p>
        <ul>
          <li>Full Name</li>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>Mailing Address</li>
          <li>Project Details and Preferences</li>
          <li>Any other information voluntarily submitted via forms or direct communication</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We may use your information for the following purposes:</p>
        <ul>
          <li>To respond to inquiries and provide services</li>
          <li>To personalize user experience</li>
          <li>To improve our services and website</li>
          <li>To process payments and send invoices</li>
          <li>To send updates, promotions, or service-related communications (you can opt-out anytime)</li>
        </ul>

        <h2>3. Data Protection and Security</h2>
        <p>
          We take appropriate technical and organizational measures to protect your personal data against unauthorized access,
          loss, or misuse. However, no method of transmission over the Internet is 100% secure.
        </p>

        <h2>4. Sharing of Information</h2>
        <p>
          We do not sell, trade, or rent your personal information to third parties. We may share data only with trusted service providers
          who assist in operating our business, as long as they agree to keep this information confidential.
        </p>

        <h2>5. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion of your data (subject to legal or contractual obligations)</li>
          <li>Withdraw consent at any time</li>
        </ul>

        <h2>6. Cookies and Tracking Technologies</h2>
        <p>
          Our website may use cookies to enhance user experience. You can choose to disable cookies through your browser settings;
          however, some parts of the site may not function properly.
        </p>

        <h2>7. Third-Party Links</h2>
        <p>
          Our website may contain links to external websites. We are not responsible for the privacy practices of those sites.
          We encourage you to review their privacy policies separately.
        </p>

        <h2>8. Changes to This Policy</h2>
        <p>
          We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with an updated
          effective date.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at:<br />
          <br />
          <strong>Email:</strong> info@professionalhouse.com<br />
          <br />
          <strong>Phone:</strong> +91-XXXXXXXXXX
        </p> */}
          </div>
        </>
      }
      <Footer />
    </>
  )
}

export default PrivacyPolicy